// Deduplicates concurrent identical GET requests at the jQuery level.
// When a GET to a URL is already in-flight, subsequent calls piggyback on the
// existing request rather than sending duplicates to the server. This prevents
// N×instance bursts from directives like iio-combo-box that each fire the same
// autocomplete endpoint on init.

// Builds the in-flight map key for a request — URL plus serialized params, so
// requests to the same URL with different query data don't coalesce.
function buildRequestKey($: JQueryStatic, opts: any): string {
  const params = opts.data
    ? (typeof opts.data === 'string' ? opts.data : $.param(opts.data))
    : '';
  return params ? `${opts.url}?${params}` : opts.url;
}

(function patchAjax($: JQueryStatic) {
  const inFlight = new Map<string, JQuery.jqXHR<any>>();
  const orig = ($ as any).ajax.bind($) as typeof $.ajax;

  ($ as any).ajax = function(urlOrSettings: any, settings?: any): any {
    const opts: any = typeof urlOrSettings === 'string'
      ? { url: urlOrSettings, ...settings }
      : { ...urlOrSettings };

    if ((opts.type || opts.method || 'GET').toUpperCase() !== 'GET' || !opts.url) {
      return orig(opts);
    }

    const key = buildRequestKey($, opts);

    // Piggyback on an identical in-flight request.
    if (inFlight.has(key)) {
      const deferred = $.Deferred<any>();
      inFlight.get(key)!
        .done((data: any, status: string, xhr: any) => {
          opts.success?.(data, status, xhr);
          deferred.resolve(data, status, xhr);
        })
        .fail((xhr: any, status: string, error: string) => {
          opts.error?.(xhr, status, error);
          deferred.reject(xhr, status, error);
        });
      return Object.assign(deferred.promise(), { abort: () => {} });
    }

    const req = orig(opts);
    inFlight.set(key, req);
    req.always(() => inFlight.delete(key));
    return req;
  };
}($));
